import { d as r } from "../internals/descriptors.js";
import { f as i } from "../internals/function-uncurry-this.js";
import { d as n } from "../internals/define-built-in-accessor.js";
var s = URLSearchParams.prototype,
  e = i(s.forEach);
!r || "size" in s || n(s, "size", {
  get: function get() {
    var r = 0;
    return e(this, function () {
      r++;
    }), r;
  },
  configurable: !0,
  enumerable: !0
});